export default function PricingFaq({
    faqs,
    currencySign
}) {
  return (
    <div className="bg-gray-900">
      <div className="mx-auto max-w-7xl py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
        <div className="lg:mx-auto lg:max-w-2xl lg:text-center">
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">Frequently asked questions</h2>
          <p className="mt-4 text-gray-400">
            Got questions around our pricing? We've got you covered.
          </p>
        </div>
        <div className="mt-20">
          <dl className="space-y-10 lg:grid lg:grid-cols-2 lg:gap-x-8 lg:gap-y-10 lg:space-y-0">
            {faqs.map((faq) => (
              <div key={faq.id}>
                <dt className="font-semibold text-white">{faq.question}</dt>
                <dd className="mt-3 text-gray-400">{faq.answer.replace('[currency]',currencySign)}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  )
}